import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import style from './LoaderDailyDose.module.sass'

export const LoaderDailyDose: FunctionComponent = () => {
	return (
		<div className={style.loadingPreviewWrapper}>
			<div className={clsx(style.loadingPreview, style.loadingPreviewTitle)} />
			<div className={clsx(style.loadingPreview, style.loadingPreviewAmount)} />
			<div className={clsx(style.loadingPreview, style.loadingPreviewPrice)} />
		</div>
	)
}
